import React, { useEffect, useState } from "react";
import PageLoader from "../loader/PageLoader";
import { Checks, Copy, X,MapPin,Envelope } from "@phosphor-icons/react";
import checkinLogo from "../../Assets/web-checkin.png";
import dayjs from "dayjs";
import axiosInstance from "../../api/axiosInstance";
import { RejectHotel } from "../Dashboard/RejectAPI";
import WebCheckInImageView from "../Dashboard/WebCheckInImageView";
import { toast } from "react-toastify";
// Web Check In Css
import "./../../Styles/WebCheckIn.css";
import { formatHotel } from "../../api/hotelTime";

const WebCheckInRequestModel = ({ selectedRequest,setRequestData,setOpenRequestModal,setRequestType }) => {

    const hotelId = localStorage.getItem("hotelId");
    const [webData, setWebData] = useState(null);
    const [guestData, setGuestData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [guestRequestId, setGuestRequestId] = useState("");
    const [imageOpen, setImageOpen] = useState(false);
    // Message for Hotel for waiting to approval or decline
    const [message, setMessage] = useState("");
    // to Show Bigger Model
   const [modalData, setModalData] = useState({
        img: "",
        name: "",
        phone: "",
        email: "",
        address: "",
    });

    useEffect(() => {
        fetchData();
    }, [selectedRequest]);

    

    // Booking Name and Booking Contact Information
    const [bookingData,setBookingData] = useState({});

    const fetchData = async () => {
        try {
            // console.log("Here");
            setLoading(true);
            const response = await axiosInstance.get(
                `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/web-checkin`,
            );
            console.log("Response for Guests : ", response.data.guest_details);
            const guestDetails = response.data.guest_details;

            try{
                const bookingResponse = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${selectedRequest.bookingId}`);
                // console.log("Booking Data : ",bookingResponse.data);
                setBookingData(bookingResponse.data);
            }catch(error){
                console.log(error);
            }

            try {
                const usersResponse = await axiosInstance.get("/api/v1/users");

                const usersData = usersResponse.data.data;

              const finalGuestsData = guestDetails.map((guest) => {
                    
                    if(!guest.is_user){
                        return guest;
                    }
                    else{
                        return guest
                    }
                    // const findGuest = usersData.find(
                    //     (user) => user.contact === guest.contact,
                    // );

                  
                    // if (findGuest) {
                    //     if(findGuest.verification_id===""){
                    //         return guest
                    //     }
                    //     else{
                    //         return {
                    //             ...guest,
                    //             name: findGuest.name, // Set the name from the user
                    //             verification_id: findGuest.verification_id, // Set the verification_id from the user
                    //         };
                    //     }
                    // }
                    // return guest;
                });

                const guestDenied = finalGuestsData.map((guest) => {
                    if (guest.guest_approved === "GUEST_DENIED") {
                        return {
                            ...guest,
                            hotel_approved: "HOTEL_DENIED",
                        };
                    }
                    return guest;
                });

                // console.log(
                //     "Final Guest Data to be Sent for Hotel : ",
                //     guestDenied,
                // );
           
                const checkGuestData = (guest) => {
                    if (guest.guest_approved === "GUEST_UNSPECIFIED") {
                        return true;
                    } else {
                        return false;
                    }
                };
                const checkGuestDeny = (guest) => {
                    if (guest.guest_approved === "GUEST_DENIED") {
                        return true;
                    } else {
                        return false;
                    }
                };
                // Check Deny Or Approval
                const checkWait = finalGuestsData.every(checkGuestData);
                if (checkWait) {
                    setMessage("Please Wait for Guest Approval");
                }
                const checkDeny = finalGuestsData.every(checkGuestDeny);
                if (checkDeny) {
                    setMessage(
                        "All the guests present in this Request has Denied",
                    );
                }

                // const guestsWithImages = await fetchImagesForGuests(
                //     response.data.guest_details,
                // );
                // const guestsWithImages = await fetchImagesForGuests(
                //     finalGuestsData,
                // );


                const guestsWithImages = await fetchImagesForGuests(
                    finalGuestsData,
                );
                setGuestRequestId(response.data?.guest_request_id);
                setGuestData(guestsWithImages);
                setWebData(response.data);
            } catch (error) {
                console.log(error);
            }
        } catch (error) {
            setErrors({ fetch: "Failed to fetch web check-in data" });
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

 
    // const fetchImagesForGuests = async (guests) => {

    //     // Fetch the image URLs for each guest's verification_id
    //     const updatedGuests = await Promise.all(
    //         guests.map(async (guest) => {
    //             try {
    //                 const response = await axiosInstance.get(
    //                     `/api/v1/images/download-presigned-url?key=${guest.verification_id}`,
    //                 );
    //                 //${guest.verification_id}
    //                 setLoading(true);
    //                 return { ...guest, imageUrl: response.data.url };
    //             } catch (error) {
    //                 console.error(
    //                     `Error fetching image for guest ${guest.id}:`,
    //                     error,
    //                 );
    //                 return { ...guest, imageUrl: "" }; // Use fallback if image fetching fails
    //             }
    //         }),
    //     );
    //     return updatedGuests;
    // };


    const fetchImagesForGuests = async (guests) => {
        const updatedGuests = await Promise.all(
            guests.map(async (guest) => {
                try {
                    // Step 1: Normalize and sanitize the verification_id field
                    const ids = guest.verification_id
                        ?.split(',')
                        .map(id => id.trim())
                        .filter(id => id); // Removes empty strings, nulls, etc.

                    // Step 2: If no valid IDs, return guest with empty imageUrls
                    if (!ids || ids.length === 0) {
                        return { ...guest, imageUrls: [] };
                    }

                    // Step 3: Fetch URLs for each valid ID
                    const imageUrls = await Promise.all(
                        ids.map(async (id) => {
                            try {
                                const response = await axiosInstance.get(
                                    `/api/v1/images/download-presigned-url?key=${id}`
                                );
                                return response.data.url;
                            } catch (err) {
                                console.error(`Error fetching image for ID "${id}":`, err);
                                return ""; // or a placeholder/fallback image URL
                            }
                        })
                    );

                    // Step 4: Return guest with array of image URLs
                    return { ...guest, imageUrls };
                } catch (error) {
                    console.error(`Error processing guest ${guest.id}:`, error);
                    return { ...guest, imageUrls: [] };
                }
            })
        );
        return updatedGuests;
    };


 
    const { checkin_date, checkout_date } = webData || "";
    const checkinDate = formatHotel(checkin_date, "DD MMMM YYYY");
    const checkoutDate = formatHotel(checkout_date, "DD MMMM YYYY");

 

    const formatContact = (contact) => {
        if (!contact) return ""; // Return empty string if no contact is available

        // Convert contact to a string and remove any non-digit characters
        const cleanNumber = contact.toString().replace(/\D/g, "");

        // If contact is more than 10 digits, assume the first part is the country code
        if (cleanNumber.length > 10) {
            const countryCode = cleanNumber.slice(0, cleanNumber.length - 10);
            const actualContact = cleanNumber.slice(-10);
            return `+${countryCode} - ${actualContact}`;
        }

        // If contact is 10 digits or less, return it as is
        return cleanNumber;
    };

    // Set Up Modal Data
    const setModalInfo = (guest, imgUrl) => {
        setModalData({
            img: imgUrl,
            name: guest.name,
            phone: guest.contact,
            email: guest.email,
            address: guest.address,
        });
        setImageOpen(true);
    };

    return (
        <>
            <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
                {loading && <PageLoader />}
 
                <form
                    className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
                    
                >
                    {/* Close Modal */}
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-semibold">
                            Web Check-In
                        </h2>
                        <button
                            onClick={() =>{
                                setOpenRequestModal(false);
                                setRequestType("");
                                setRequestData(null);
                            }}
                            className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                            type="button"
                        >
                            <X weight="bold" size={18} />
                        </button>
                    </div>

                    <div className="flex flex-col gap-4">
                        {/* General Details */}
                        <div className="flex items-center justify-between gap-2">

                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Booking ID
                                </p>
                                <div className="flex items-center gap-2 w-[90%]">
                                    <p
                                        className="truncate pr-4"
                                        title={selectedRequest?.bookingId || ""}
                                    >
                                        {selectedRequest?.bookingId || ""}
                                    </p>
 
                                </div>
                            </div>

                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Check-in Date
                                </p>
                                <p>{checkinDate}</p>
                            </div>

                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Check-out Date
                                </p>
                                <p>{checkoutDate}</p>
                            </div>
                        </div>

                        <div className="flex items-center   gap-2">
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Booking Name
                                </p>
                                <div className="flex items-center gap-2 w-[90%]">
                                    <p
                                        className="truncate pr-4"
                                        title={bookingData?.name || 'Booking Name'}
                                    >
                                        {bookingData?.name || "booking name"}
                                    </p>
                                    
                                </div>
                            </div>

                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Booking Contact
                                </p>
                                <div className="flex items-center gap-2 w-[90%]">
                                    <p
                                        className="truncate pr-4"
                                        title={bookingData?.contact || 'Booking Contact'}
                                    >
                                        +{bookingData?.contact || "booking contact"}
                                    </p>
                                    
                                </div>
                            </div>
                        </div>

                        {/* Guests  */}
                      <div className="webScroll  flex flex-wrap max-w-full   gap-1 ">
                                {message === "" ? (
                                    guestData.map(
                                        (guest, index) =>
                                            guest.guest_approved ===
                                                "GUEST_APPROVED" && (
                                                <div
                                                    className="w-[calc(33.333%-0.5rem)] border-[1.5px] border-[#BFC4CC] bg-[#EEF0FB] rounded-md overflow-hidden "
                                                    key={index}
                                                >
                                                    <div className="flex gap-2 overflow-x-scroll h-[160px] overflow-y-hidden">
                                                        {/* {console.log("-------------", guest)} */}
                                                        {/* Guest Image */}
                                                            {guest.imageUrls && guest.imageUrls.length > 0 ? (
                                                                guest.imageUrls.map((url, index) => (
                                                                    <img
                                                                        key={index}
                                                                        src={url}
                                                                        alt={`Guest ID ${guest.verification_id} - Image ${index + 1}`}
                                                                        className="w-full h-[210px] object-cover bg-center cursor-pointer mb-2"
                                                                        onLoad={() => setLoading(false)}
                                                                        onError={() => setLoading(false)}
                                                                        onClick={() => setModalInfo(guest, guest.imageUrls)}
                                                                    />
                                                                ))
                                                            ): (
                                                            <>
                                                                <img
                                                                    src={
                                                                        checkinLogo
                                                                    }
                                                                    alt="checkin-logo"
                                                                    className="w-full h-28 bg-center"
                                                                    onLoad={() =>
                                                                        setLoading(
                                                                            false,
                                                                        )
                                                                    } // Stop loading if no image is available
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                 

                                                    

                                                    <div className="p-2">
                                                        {/* Guest Name */}
                                                        <p className="text-[16px] font-semibold mb-2">
                                                            {guest?.name || "Guest Name"}
                                                        </p>

                                                        <div className="flex flex-col gap-1">
                                                            {/* Guest Contact */}
                                                            <p className="text-xs">
                                                                {formatContact(
                                                                    guest?.contact,
                                                                )}
                                                            </p>
                                                            {/* Guest Mail */}
                                                            <div className="flex items-center text-xs gap-1">
                                                                <div><Envelope size={18}/></div>
                                                                <div>{guest?.email || "email"}</div>
                                                            </div>
                                                            {/* Guest Address */}
                                                            <div className="truncate flex items-center text-xs gap-1">
                                                                <div><MapPin size={18}/></div>
                                                                <div>{guest?.address?.length > 6 ? guest.address.slice(0, 6)+"..." : guest?.address}</div>
                                                            </div>
                                                        </div>
                                            
                                                        {/* Guest Status */}
                                                        {/* <p className="text-xs pt-1">
                                                            Status :{" "}
                                                            {guest.guest_approved ===
                                                            "GUEST_APPROVED"
                                                                ? "Guest Approved"
                                                                : guest.guest_approved ===
                                                                  "GUEST_UNSPECIFIED"
                                                                ? "Guest Unspecified"
                                                                : ""}
                                                        </p> */}

                                                 
                                                    </div>
                                                </div>
                                            ),
                                    )
                                ) : (
                                    <div className="flex items-center justify-center m-auto h-[230px] font-bold text-[#FF5A5F]">
                                        <h4>{message}</h4>
                                    </div>
                                )}
                            </div>



                    </div>

                    {errors.fetch && (
                        <p className="text-red-500">{errors.fetch}</p>
                    )}

                </form>
             
            </div>

            <WebCheckInImageView
                imageOpen={imageOpen}
                setImageOpen={setImageOpen}
                modalData={modalData}
            />
        </>
    );
};

export default WebCheckInRequestModel;
